import React, { Component } from "react";
import { Route, HashRouter } from "react-router-dom";
import { PanelMenu } from "primereact/panelmenu";
import { connect } from "react-redux";
import "./primeicons.css";

import logo from "../Images/logo.png";
import text from "../Images/textsmall.png";

import Support from "../Common/support";
import Center from "../Common/CenterDetails";

import TestUpload from "../Common/TestUpload";

import Home from "../Modules/Home/Home";
import Patient from "../Modules/Patients/Patient";
import Volunteer from "../Modules/Volunteers/Volunteer";
import PatientAdd from "../Modules/Patients/PatientAddEdit";
import HomeCarePlan from "../Modules/Patients/HomeCarePlan";
import Rehabilitation from "../Modules/Patients/Rehabilitation";
import OP from "../Modules/Patients/OP";
import Accounts from "../Modules/Accounts/Accounts";
import Panjayath from "../Modules/Panjayath/Panjayath";
import Routes from "../Modules/Route/Route";
import IncomeType from "../Modules/IncomeType/IncomeType";
import ExpType from "../Modules/ExpenseType/ExpenseType";
import AccountsAdd from "../Modules/Accounts/AccountsAddEdit";
import PendingCheque from "../Modules/Accounts/PendingCheques";
import Medicine from "../Modules/Medicine/Medicine";
import MedicineOutbound from "../Modules/Medicine/Outbound";
import MedicineInbound from "../Modules/Medicine/Inbound";
import MedicineReturn from "../Modules/Medicine/Return";
import ReportHome from "../Modules/Report/ReportHome";
import Diagnosis from "../Modules/Diagnosis/Diagnosis";
import Bank from "../Modules/Bank/Bank";
import BankLedger from "../Modules/BankLedger/BankLedger";
import CashBalance from "../Modules/CashBalance/CashBalance";
import Equipment from "../Modules/Equipments/Equipment";
import EquipmentTracker from "../Modules/Equipments/EquipmentTracker";

import AZINCog from "../Modules/Orders/AmazonIndia/Cog/Cog";
import FKCog from "../Modules/Orders/Flipkart/Cog/Cog";
import AZINSku from "../Modules/Orders/AmazonIndia/SKU/Sku";
import FKSku from "../Modules/Orders/Flipkart/SKU/Sku";
import AZINExtract from "../Modules/Orders/AmazonIndia/Extract";
import FKExtract from "../Modules/Orders/Flipkart/Extract"


class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [
        {
          label: "Dashboard",
          command: event => {
            window.location.hash = "/";
          }
        },
        {
          label: "Account",
          icon: "pi pi-dollar",
          items: [
            {
              icon: "pi pi-fw pi-bars",
              label: "Ledger",
              command: event => {
                window.location.hash = "/accounts";
              }
            }
          ]
        },
        {
          label: "Orders",
          icon: "pi pi-shopping-cart",
          items: [
            {
              label: "Amazon India",
              items: [
                {
                  icon: "pi pi-arrow-circle-right",
                  label: "Extract",
                  command: event => {
                    window.location.hash = "/AZINExtract";
                  }
                },
                {
                  icon: "pi pi-arrow-circle-right",
                  label: "COG",
                  command: event => {
                    window.location.hash = "/AZINCog";
                  }
                },
                {
                  icon: "pi pi-arrow-circle-right",
                  label: "Cosmetic SKUs",
                  command: event => {
                    window.location.hash = "/AZINSku";
                  }
                },
              ]
            },
            {
              label: "Flipkart",
              items: [
                {
                  icon: "pi pi-arrow-circle-right",
                  label: "Extract",
                  command: event => {
                    window.location.hash = "/FKExtract";
                  }
                },
                {
                  icon: "pi pi-arrow-circle-right",
                  label: "COG",
                  command: event => {
                    window.location.hash = "/FKCog";
                  }
                },
                {
                  icon: "pi pi-arrow-circle-right",
                  label: "Wallet SKUs",
                  command: event => {
                    window.location.hash = "/FKSku";
                  }
                },
              ]
            }
          ]
        },
        {
          label: "Report",
          icon: "pi pi-chart-bar",
          items: [
            {
              label: "Account",
              icon: "pi pi-dollar",
              items: [
                {
                  icon: "pi pi-fw pi-file",
                  label: "Day Book",
                  command: event => {
                    window.location.hash = "/reportDayBook";
                  }
                },
                {
                  icon: "pi pi-fw pi-briefcase",
                  label: "Monthly Report",
                  command: event => {
                    window.location.hash = "/reportMonthly";
                  }
                }
                // {
                //   label: "Receipt/Voucher",
                //   icon: "pi pi-money-bill",
                //   command: event => {
                //     window.location.hash = "/reportReceipt";
                //   }
                // }
              ]
            }
          ]
        },
        {
          label: "Settings",
          icon: "pi pi-cog",
          items: [
            {
              icon: "pi pi-home",
              label: "Center Details",
              command: event => {
                window.location.hash = "/center";
              }
            },
            {
              label: "Income Type",
              icon: "pi pi-money-bill",
              command: event => {
                window.location.hash = "/incomeType";
              }
            },
            {
              label: "Expense Type",
              icon: "pi pi-money-bill",
              command: event => {
                window.location.hash = "/expType";
              }
            },
            {
              label: "Bank Details",
              icon: "pi pi-dollar",
              command: event => {
                window.location.hash = "/bank";
              }
            }
          ]
        },
        //https://www.primefaces.org/showcase/icons.xhtml?jfwid=b7a94
        {
          label: "Support",
          command: event => {
            window.location.hash = "/support";
          }
        },
        {
          label: "Test Upload",
          command: event => {
            window.location.hash = "/testUpload";
          }
        },
        {
          label: "Logout",
          icon: "pi pi-sign-out",
          command: event => {
            this.props.handleLogoff();
          }
        }
      ],
      dummy: { _id: "NA" }
    };
  }

  render() {
    return (
      <HashRouter>
        <div>
          <div className="bannerInner">
            <img src={logo} width="60px" height="60px" />
            <img src={text} width="400px" height="60px" />
          </div>
          {/* <div>aaa</div> */}
        </div>
        <div className="container-fluid">
          <div className="row p-1">
            <div className="col col-md-2 nopadding">
              <PanelMenu model={this.state.items} />
            </div>
            <div className="col col-md-10 content-section implementation">
              <Route exact path="/" component={Home} />
              <Route path="/patient" component={Patient} />
              <Route
                path="/patientadd"
                render={() => (
                  <PatientAdd source="menu" pData={this.state.dummy} />
                )}
              />
              <Route path="/accounts" component={Accounts} />
              <Route path="/volunteer" component={Volunteer} />
              <Route path="/panjayath" component={Panjayath} />
              <Route path="/route" component={Routes} />
              <Route path="/diagnosis" component={Diagnosis} />
              <Route path="/center" component={Center} />
              <Route path="/incomeType" component={IncomeType} />
              <Route path="/expType" component={ExpType} />
              <Route
                path="/addIncome"
                render={() => (
                  <AccountsAdd
                    source="menu"
                    pData={this.state.dummy}
                    txnType="Income"
                  />
                )}
              />
              <Route
                path="/addExpense"
                render={() => (
                  <AccountsAdd
                    source="menu"
                    pData={this.state.dummy}
                    txnType="Expense"
                  />
                )}
              />
              <Route path="/medicine" component={Medicine} />
              <Route path="/medicineInbound" component={MedicineInbound} />
              <Route path="/medicineOutbound" component={MedicineOutbound} />
              <Route path="/medicineReturn" component={MedicineReturn} />
              <Route path="/equipment" component={Equipment} />
              <Route path="/equipmentTracker" component={EquipmentTracker} />
              <Route
                path="/reportNextOP"
                render={() => (
                  <ReportHome reportType="Patient" reportSubType="Next OP" />
                )}
              />
              <Route
                path="/reportPatientCount"
                render={() => (
                  <ReportHome reportType="Patient" reportSubType="Count" />
                )}
              />
              <Route
                path="/reportPatientDetails"
                render={() => (
                  <ReportHome reportType="Patient" reportSubType="Details" />
                )}
              />
              <Route
                path="/reportHomeCare"
                render={() => (
                  <ReportHome reportType="Patient" reportSubType="Home Care" />
                )}
              />
              <Route
                path="/reportMonthly"
                render={() => (
                  <ReportHome reportType="Accounts" reportSubType="Monthly" />
                )}
              />
              <Route
                path="/reportDayBook"
                render={() => (
                  <ReportHome reportType="Accounts" reportSubType="DayBook" />
                )}
              />
              <Route
                path="/reportAccounts"
                render={() => (
                  <ReportHome
                    reportType="Accounts"
                    reportSubType="Account Summary"
                  />
                )}
              />
              <Route
                path="/reportIncome"
                render={() => (
                  <ReportHome
                    reportType="Accounts"
                    reportSubType="Income Details"
                  />
                )}
              />
              <Route
                path="/reportExpense"
                render={() => (
                  <ReportHome
                    reportType="Accounts"
                    reportSubType="Expense Details"
                  />
                )}
              />
              <Route
                path="/reportReceipt"
                render={() => (
                  <ReportHome reportType="Accounts" reportSubType="Receipt" />
                )}
              />
              <Route
                path="/reportCheque"
                render={() => (
                  <ReportHome reportType="Accounts" reportSubType="Cheque" />
                )}
              />

              <Route
                path="/reportMedStock"
                render={() => <ReportHome reportType="MedStock" />}
              />
              <Route
                path="/reportMedTracker"
                render={() => <ReportHome reportType="MedTracker" />}
              />
              <Route
                path="/reportMedExpiry"
                render={() => <ReportHome reportType="MedExpiry" />}
              />
              <Route
                path="/reportMedThreshold"
                render={() => <ReportHome reportType="MedThreshold" />}
              />
              <Route
                path="/reportEquipment"
                render={() => (
                  <ReportHome reportType="Equipment" reportSubType="Tracker" />
                )}
              />
              <Route
                path="/reportEqDispose"
                render={() => (
                  <ReportHome reportType="Equipment" reportSubType="Dispose" />
                )}
              />
              <Route path="/support" component={Support} />
              <Route path="/testUpload" component={TestUpload} />
              <Route path="/cashBalance" component={CashBalance} />
              <Route path="/bank" component={Bank} />
              <Route path="/bankLedger" component={BankLedger} />
              <Route path="/pendingCheque" component={PendingCheque} />
              <Route path="/homeCarePlan" component={HomeCarePlan} />
              <Route path="/rehabilitation" component={Rehabilitation} />
              <Route path="/patientOP" component={OP} />

              <Route path="/AZINCog" component={AZINCog} />
              <Route path="/FKCog" component={FKCog} />
              <Route path="/AZINSku" component={AZINSku} />
              <Route path="/FKSku" component={FKSku} />
              <Route path="/AZINExtract" component={AZINExtract} />
              <Route path="/FKExtract" component={FKExtract} />

            </div>
          </div>
        </div>
        <br />
        <br />
      </HashRouter>
    );
  }
}

const mapStateToProps = state => {
  return {
    st: state
  };
};

// export default connect(mapStateToProps)(Main);
export default Main;
